var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "global-search__categories",
    },
    [
      _c(
        "ul",
        { staticClass: "category__list filter--list" },
        [
          _vm._l(_vm.categories, function (category) {
            return [
              _c(
                "li",
                {
                  key: category.id,
                  class: [
                    "category--name",
                    category.kind === _vm.activeCategory ? "active" : "",
                    _vm.categoryIsEnabled(category) ? "" : "disabled",
                    category.kind === _vm.kinds.all ? "hide-smartphone" : "",
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.changeResults(category)
                    },
                  },
                },
                [
                  _vm._v("\n                " + _vm._s(category.name) + " "),
                  _c("span", { staticClass: "category--count" }, [
                    _vm._v("(" + _vm._s(category.count) + ")"),
                  ]),
                ]
              ),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }